import React, { useEffect } from "react";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";

import { modalViewGAEvent } from "../../utils/ga";
import "./styles.scss";

export interface IModalConfirmProps {
  title: string;
  description?: string;
  secondaryDescription?: string;
  cancelLabel: string;
  confirmLabel: string;
  onClose: () => void;
  onConfirm: (event: React.MouseEvent) => void;
  children?: React.ReactNode;
  color?: "blue" | "red";
  translate?: boolean;
  disableConfirm?: boolean;
}

export const ModalConfirm: React.FunctionComponent<IModalConfirmProps> = (
  props
) => {
  const {
    title,
    description,
    secondaryDescription,
    cancelLabel,
    confirmLabel,
    onClose,
    onConfirm,
    children,
    color = "blue",
    translate = true,
    disableConfirm = false,
  } = props;

  const { t: _t } = useTranslation();
  // Some components pass translation keys for the modal to translate,
  // other components pass the actual text to be displayed.
  // TODO: It might be better to refactor this to always pass the actual text to be displayed,
  // i.e. the parent should handle translation.
  const t = translate
    ? (key: string) => _t(`modalConfirm.${key}`)
    : (key: string) => key;

  // Send GA event on open
  useEffect(() => {
    modalViewGAEvent("confirm-modal");
  }, []);

  return (
    <div className="modal-default modal-confirm">
      <div className="modal-mains">
        <button
          className="btn-close"
          onClick={() => {
            ReactGA.event({
              category: "Confirm modal",
              action: "Cancel",
            });
            onClose();
          }}
        ></button>
        <div className="top-title">{t(title)}</div>
        {(description || secondaryDescription) && (
          <div className="description-txt">
            {description ? t(description) : null}
            {secondaryDescription ? secondaryDescription : null}
          </div>
        )}
        <div className="confirm-content-container">
          <div className="confirm-content">{children}</div>
        </div>
        <div className="bottom-btns">
          {cancelLabel !== "" && (
            <button
              className="btn btn-border"
              onClick={() => {
                ReactGA.event({
                  category: "Confirm modal",
                  action: "Cancel",
                });
                onClose();
              }}
            >
              {t(cancelLabel)}
            </button>
          )}
          <button
            className={`btn btn-${color}`}
            onClick={(event) => {
              ReactGA.event({
                category: "Confirm modal",
                action: "Confirm",
              });
              onConfirm(event);
            }}
            disabled={disableConfirm}
          >
            {t(confirmLabel)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirm;
